<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form)=>{this.searchForm = form}">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="搜索用户id" fieldDecoratorId="uid">
              <a-input placeholder="ID"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="操作人" fieldDecoratorId="admin_user_name">
              <a-input placeholder="操作人"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择"  allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="充值日期" fieldDecoratorId="date_range">
              <a-range-picker />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              label="充值类型"
              fieldDecoratorId="type"
            >
              <a-select placeholder="请选择充值类型" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="d in rechargeTypes" :key="d.val">{{
                  d.text
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType='submit'>查询</a-button>
              <a-divider type="vertical" />
              <a-button style="margin-left: 3px" @click="handleExport">导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
    >
    <template slot="type" slot-scope="text">
        {{text|typeFilter}}
      </template>
      <template slot="avatar" slot-scope="text">
        <span class="avatar"><img :src="text"></span>
      </template>
      <template slot="admin_user_name" slot-scope="text">
        {{ text || '机器充值' }}
      </template>
      <template slot="branch_name" slot-scope="text">
        {{ text || '总部' }}
      </template>
    </s-table>
  </a-card>
</template>
<script>

import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'
import { getBranchList } from '@/api/branch'
import { getUserRecordList } from '@/api/user' 
import { encodeJsonToQuery } from '@/utils/util'
import { ACCESS_TOKEN } from "@/store/mutation-types"

export default {
  name: "UserRecordList",
  components: {
    AInput,
    STable
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      searchForm: null,
      advanced: false,
      options:[],
      branches:[],
      queryParam: {},
      // 表头
      columns: [
        {
          title: '用户ID',
          dataIndex: 'uid'
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname'
        },
        {
          title: '充值类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type'}
        },
        {
          title: '充值门店',
          dataIndex: 'branch_name',
          scopedSlots: { customRender: 'branch_name' },
        },
        {
          title: '充值数量',
          dataIndex: 'change_quantity',
        },
        {
          title: '操作人',
          dataIndex: 'admin_user_name',
          scopedSlots: { customRender: 'admin_user_name' },
        },
        {
          title: '时间',
          dataIndex: 'created'
        }
      ],
      rechargeTypes:[
        {
          val:1,
          text:'充值'
        },
        {
          val:2,
          text:'扣减'
        },
        {
          val:3,
          text:'退款'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        return getUserRecordList(Object.assign(params, this.queryParam)).then(res => res)
      },
    }
  },
  filters: {
    typeFilter: function(value) {
      if (value > 3) {
        return '其他'
      }
      const types = ['兑换', '充值', '扣减','退款']
      return types[value]
    }
  },
  created () {
    this.getBranchList()
  },
  methods: {
    getBranchList: function () {
      getBranchList().then(res => {
        this.branches = res.list
      })
    },
    handleSearch(e) {
      e.preventDefault()
      let filter = {
        uid: this.searchForm.getFieldValue('uid'),
        branch_id: this.searchForm.getFieldValue('branch_id'),
        admin_user_name: this.searchForm.getFieldValue('admin_user_name'),
        type: this.searchForm.getFieldValue('type'),
      };
      const date_range = this.searchForm.getFieldValue("date_range");
      if (date_range) {
        filter["start_date"] = date_range[0].format("YYYY-MM-DD");
        filter["end_date"] = date_range[1].format("YYYY-MM-DD");
      }
      this.queryParam = {
       ...filter
      }
      this.$refs.table.refresh()
    },
    handleExport(){
      let params = {
        uid: this.searchForm.getFieldValue('uid'),
        branch_id: this.searchForm.getFieldValue('branch_id'),
        admin_user_name: this.searchForm.getFieldValue('admin_user_name'),
        type: this.searchForm.getFieldValue('type'),
        token:this.$ls.get(ACCESS_TOKEN)
      }
      const date_range = this.searchForm.getFieldValue("date_range");
      if (date_range) {
        params["start_date"] = date_range[0].format("YYYY-MM-DD");
        params["end_date"] = date_range[1].format("YYYY-MM-DD");
      }
      window.open("/api/admin/user/recharge/record/excel" + encodeJsonToQuery(params))
    }
  },
}
</script>
<style scoped>
.avatar {
  width: 48px;
  height: 48px;
}
.avatar>img {
  width: 48px;
  height: 48px;
  display: block;
  border-radius: 50%;
}
</style>

